import {Box, IconButton, Typography} from '@mui/material';

import {AnalyticsBreakdownList} from './AnalyticsBreakdownList';
import {AnalyticsSectionRow} from './AnalyticsSectionRow';
import {AnalyticsStatusRow} from './AnalyticsStatusRow';
import {InfoIcon} from '../../../../assets/employee_satisfaction_bar';
import {EmpionTooltip} from '../../../../components/EmpionTooltip/EmpionTooltip';
import {greenColors} from '../../../../layouts/theme/designSystem';

export interface MetricItem {
  label: string;
  value: string | number;
}

export interface StatusItem {
  label: string;
  selected?: boolean;
}

export interface BreakdownItem {
  label: string;
  value: string;
}

interface Props {
  title: string;
  metrics?: MetricItem[];
  statuses?: StatusItem[];
  breakdownItems?: BreakdownItem[];
  gridRows?: number;
  infoTooltip?: string;
}

export const AnalyticsSection = ({title, metrics, statuses, breakdownItems, gridRows, infoTooltip}: Props) => {
  return (
    <Box sx={{marginTop: 4}}>
      <Box display='flex' alignItems='center' gap={0.5} marginBottom={2}>
        <Typography
          variant='h3'
          sx={{
            color: greenColors[700],
          }}
        >
          {title}
        </Typography>
        {infoTooltip && (
          <EmpionTooltip title={infoTooltip || 'Test'} isEnabled={!!infoTooltip} placement='right'>
            <IconButton size='small'>
              <InfoIcon fill={greenColors[700]} height={19} width={19} />
            </IconButton>
          </EmpionTooltip>
        )}
      </Box>

      {metrics && <AnalyticsSectionRow metrics={metrics} gridRows={gridRows} />}
      {statuses && <AnalyticsStatusRow statuses={statuses} />}
      {breakdownItems && <AnalyticsBreakdownList items={breakdownItems} />}
    </Box>
  );
};
